import { fetchFooter } from 'components/Footer/FooterActions';

import routes from '../../../../webpack/local/sitemap.json';

export const FETCH_SITE_CONTENT = 'FETCH_SITE_CONTENT';

function fetchSitemap() {
  const payload = { data: routes };

  return {
    type: FETCH_SITE_CONTENT,
    payload,
  };
}

export const fetchSiteContent = () => dispatch =>
  dispatch(fetchFooter()).then(() => dispatch(fetchSitemap()));
